import React from "react";
import { cn } from "@/lib/utils";
import { useInView } from "@/hooks/useInView";

export const AnimatedSection = ({
  as: Comp = "section",
  className,
  children,
  delay = 0,
  once = true,
  rootMargin,
  threshold,
  ...rest
}) => {
  const { ref, inView } = useInView({ once, rootMargin, threshold });

  return (
    <Comp
      ref={ref}
      className={cn("motion-reveal", className)}
      data-inview={inView ? "true" : "false"}
      style={{ transitionDelay: `${delay}ms` }}
      {...rest}
    >
      {children}
    </Comp>
  );
};

export const HoverGlow = ({ className, children }) => {
  return (
    <div className={cn("shine-border", className)}>
      <div className="shine-border__inner">{children}</div>
    </div>
  );
};
